import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { OnlyLettersAndNumbersValidator } from 'src/app/directives/only-letters-and-numbers-validator.directive';
import { Signingreasons } from 'src/app/models/signingreasons';

@Component({
  selector: 'app-reasonlist',
  templateUrl: './reason-list.component.html'
})
export class ReasonListComponent implements OnInit {
  @Input('showReason') showReason: boolean = false;
  @Input('reasons') reasons: Signingreasons[] = [];
  @Output('AddReason') AddReason: EventEmitter<Signingreasons> = new EventEmitter<Signingreasons>();
  @Output('RemoveReason') RemoveReason: EventEmitter<number> = new EventEmitter<number>();
  @Output('updateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  @Output('reasonChangeOrder') reasonChangeOrder: EventEmitter<CdkDragDrop<Signingreasons[]>> = new EventEmitter<CdkDragDrop<Signingreasons[]>>();
  currentUrl: any[] = [];
  form: UntypedFormGroup;
  newReasonControl: FormControl;
  invalidInput: boolean = false;
  reasonAlreadyExist: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder) {
    this.newReasonControl = new UntypedFormControl('', [Validators.required, OnlyLettersAndNumbersValidator(),]);
    this.form = this.formBuilder.group(
      {
        reason: this.newReasonControl
      }
    );
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  addReason() {
    let reason: Signingreasons = {
      reason: this.form.get('reason')!.value,
      id: 0,
      ordinal: null
    };
    this.AddReason.emit(reason);
    this.form.reset('reason');
  }

  removeReason(reasonId: number) {
    this.RemoveReason.emit(reasonId);
  }

  toggleShowSigningReason(event: any) {
    let key = 'ShowReason';
    let checked = (event.target as HTMLInputElement).checked;
    this.updateOrganisationSettings.emit({'checked': checked, 'key': key});
  }

  reasonDropped(event: CdkDragDrop<Signingreasons[]>) {
    this.reasonChangeOrder.emit(event);
  }

  fieldChange(key: string): boolean {
    const formField = document.getElementById(key);
    this.invalidInput = false;
    this.reasonAlreadyExist = false;

    if (!formField) return true;

    if (this.reasons && this.form.controls[key].value && this.reasons.some(i => i.reason.toLowerCase() === this.form.controls[key].value.toLowerCase())) {
      formField.classList.add('is-invalid');
      this.invalidInput = true;
      this.reasonAlreadyExist = true;
      return false;
    }

    if (this.form.controls[key].invalid) {
      formField.classList.add('is-invalid');
      return false;
    }

    formField.classList.remove('is-invalid');
    return true;
  }

}

